module.exports = __webpack_public_path__ + "media/assets/images/tour/5_Tour_5-9ac35ab54b0fa038327c9e6f7e4fa45e.png";